import { MarketTrendsTable } from './MarketTrendsTable.js';
import { MarketTrendsHelpers } from './types.js';

type Props = {
  marketTrendsHelpers: MarketTrendsHelpers;
};

export function MarketTrendsSummaryTable(props: Props) {
  const { marketTrendsHelpers } = props;
  return <MarketTrendsTable chunkSize={6} marketTrendsHelpers={marketTrendsHelpers} />;
}
